export const EXPORT_SUCCESS_MESSAGE = 'Your file is being created. When it\'s ready, you\'ll receive a confirmation email';
export const EXPORT_ERROR_MESSAGE = 'Starting contacts exportation failed';
